import { Instance } from 'mobx-state-tree';
import { BulkUpdateVisitsErrorDtoModelBase } from './BulkUpdateVisitsErrorDtoModel.base';

/* The TypeScript type of an instance of BulkUpdateVisitsErrorDtoModel */
export interface BulkUpdateVisitsErrorDtoModelType extends Instance<typeof BulkUpdateVisitsErrorDtoModel.Type> {}

/* A graphql query fragment builders for BulkUpdateVisitsErrorDtoModel */
export { selectFromBulkUpdateVisitsErrorDto, bulkUpdateVisitsErrorDtoModelPrimitives, BulkUpdateVisitsErrorDtoModelSelector } from './BulkUpdateVisitsErrorDtoModel.base';

/**
 * BulkUpdateVisitsErrorDtoModel
 */
export const BulkUpdateVisitsErrorDtoModel = BulkUpdateVisitsErrorDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
